import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'

import { history } from './store'

// import SignIn from "./components/SignIn";
import TodoViewLoader from './components/TodoViewLoader'

const Router = () => (
  <ConnectedRouter history={history}>
    <Switch>
      <Route exact path='/' component={TodoViewLoader} />
      <Route exact path='/:listId/:filter?' component={TodoViewLoader} />
    </Switch>
  </ConnectedRouter>
)

export default Router



// WEBPACK FOOTER //
// ./src/router.js